var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Pre icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11428_46276",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11428_46276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "download",
    d: "M5.25 16.2474C4.83333 16.2474 4.47917 16.1016 4.1875 15.8099C3.89583 15.5182 3.75 15.1641 3.75 14.7474L3.75 12.4974H5V14.7474C5 14.803 5.02778 14.8585 5.08333 14.9141C5.13889 14.9696 5.19444 14.9974 5.25 14.9974L14.75 14.9974C14.8056 14.9974 14.8611 14.9696 14.9167 14.9141C14.9722 14.8585 15 14.803 15 14.7474V12.4974H16.25V14.7474C16.25 15.1641 16.1042 15.5182 15.8125 15.8099C15.5208 16.1016 15.1667 16.2474 14.75 16.2474H5.25ZM10 13.0182L6.4375 9.45573L7.3125 8.53906L9.375 10.6016V3.60156H10.625V10.6016L12.6875 8.53906L13.5625 9.45573L10 13.0182Z",
    fill: "#969696"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.72d4fe8b7278db7e7ede80bedc9e8971.svg";
export { ForwardRef as ReactComponent };